import { environment } from './environments/environment';

const RETURN_URL_STORAGE_KEY = 'dt-return-url';
const LOGIN_PATH = '/login';
const DEFAULT_POST_AUTH_PATH = '/';

function normalizeInternalPath(path: string): string | null {
  if (!path) {
    return null;
  }

  try {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) {
      return null;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

function getPathname(path: string): string | null {
  const normalized = normalizeInternalPath(path);
  if (!normalized) {
    return null;
  }

  return new URL(normalized, window.location.origin).pathname;
}

export function getAuthCallbackPath(): string {
  return new URL(environment.auth.redirectUri, window.location.origin).pathname || '/auth/callback';
}

export function isAuthCallbackPath(path: string = window.location.pathname): boolean {
  return getPathname(path) === getAuthCallbackPath();
}

export function isLoginPath(path: string = window.location.pathname): boolean {
  return getPathname(path) === LOGIN_PATH;
}

export function getCurrentAppPath(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function setReturnUrl(path: string): void {
  const normalized = normalizeInternalPath(path);
  if (!normalized || isAuthCallbackPath(normalized) || isLoginPath(normalized)) {
    return;
  }

  sessionStorage.setItem(RETURN_URL_STORAGE_KEY, normalized);
}

export function rememberCurrentAppPathForPostAuth(): void {
  setReturnUrl(getCurrentAppPath());
}

export function getReturnUrl(): string | null {
  const storedValue = sessionStorage.getItem(RETURN_URL_STORAGE_KEY);
  if (!storedValue) {
    return null;
  }

  const normalized = normalizeInternalPath(storedValue);
  if (!normalized || isAuthCallbackPath(normalized) || isLoginPath(normalized)) {
    sessionStorage.removeItem(RETURN_URL_STORAGE_KEY);
    return null;
  }

  return normalized;
}

export function clearReturnUrl(): void {
  sessionStorage.removeItem(RETURN_URL_STORAGE_KEY);
}

export function getDefaultPostAuthPath(): string {
  return DEFAULT_POST_AUTH_PATH;
}